
const timelineData = [
  {
    week: "W1",
    "Pricing Confusion": 12,
    "Support Response Time": 8,
    "Dashboard 2.0 UI": 15,
    "Onboarding Flow Issues": 6,
    "Feature Request Excitement": 22,
    "API Integration Challenges": 9,
    events: [],
  },
  {
    week: "W2",
    "Pricing Confusion": 28,
    "Support Response Time": 18,
    "Dashboard 2.0 UI": 32,
    "Onboarding Flow Issues": 14,
    "Feature Request Excitement": 8,
    "API Integration Challenges": 25,
    events: [{ type: "meeting", name: "Sprint Planning", impact: "negative" }],
  },
  {
    week: "W3",
    "Pricing Confusion": 8,
    "Support Response Time": 12,
    "Dashboard 2.0 UI": 45,
    "Onboarding Flow Issues": 22,
    "Feature Request Excitement": 35,
    "API Integration Challenges": 15,
    events: [{ type: "milestone", name: "Feature Complete", impact: "positive" }],
  },
  {
    week: "W4",
    "Pricing Confusion": 35,
    "Support Response Time": 28,
    "Dashboard 2.0 UI": 18,
    "Onboarding Flow Issues": 8,
    "Feature Request Excitement": 42,
    "API Integration Challenges": 12,
    events: [{ type: "deadline", name: "Product Launch", impact: "mixed" }],
  },
  {
    week: "W5",
    "Pricing Confusion": 15,
    "Support Response Time": 6,
    "Dashboard 2.0 UI": 8,
    "Onboarding Flow Issues": 4,
    "Feature Request Excitement": 55,
    "API Integration Challenges": 3,
    events: [{ type: "celebration", name: "Launch Success", impact: "positive" }],
  },
]

const behaviorFlags = [
  { week: "W2", type: "pricing_spike", message: "Pricing confusion spiked during Sprint Planning" },
  { week: "W3", type: "dashboard_feedback", message: "Dashboard 2.0 UI feedback increased after feature completion" },
  { week: "W5", type: "excitement_peak", message: "Feature request excitement peaked post-launch" },
]

const chartConfig = {
  "Pricing Confusion": {
    label: "Pricing Confusion",
    color: "#ef4444",
  },
  "Support Response Time": {
    label: "Support Response Time",
    color: "#f97316",
  },
  "Dashboard 2.0 UI": {
    label: "Dashboard 2.0 UI",
    color: "#06b6d4",
  },
  "Onboarding Flow Issues": {
    label: "Onboarding Flow Issues",
    color: "#8b5cf6",
  },
  "Feature Request Excitement": {
    label: "Feature Request Excitement",
    color: "#10b981",
  },
  "API Integration Challenges": {
    label: "API Integration Challenges",
    color: "#f59e0b",
  },
}

interface TimelineChartProps {
  organizationFilter?: string
  trackerFilter?: string
}

export function TimelineChart({ organizationFilter, trackerFilter }: TimelineChartProps) {
  return null
}
